// ClassSparkline — a tiny Recharts line sparkline for the By Asset Class headers.
// Fixed-size (no ResponsiveContainer), hidden axes with a data-hugging Y domain so
// the line uses the full height, and no tooltip/animation — it reads as a static
// trend mark, matching the design's per-class spark.
import PropTypes from 'prop-types';
import { LineChart, Line, XAxis, YAxis } from 'recharts';

export function ClassSparkline({ data, color = 'var(--brand-blue)', width = 68, height = 22 }) {
  if (!data || data.length < 2) return null;
  const series = data.map((v, i) => ({ i, v }));

  return (
    <LineChart
      width={width}
      height={height}
      data={series}
      margin={{ top: 3, right: 2, bottom: 3, left: 2 }}
    >
      <XAxis dataKey="i" hide />
      <YAxis hide domain={['dataMin', 'dataMax']} />
      <Line
        type="monotone"
        dataKey="v"
        stroke={color}
        strokeWidth={1.6}
        dot={false}
        isAnimationActive={false}
      />
    </LineChart>
  );
}

ClassSparkline.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ClassSparkline;
